import React from "react";
import styled from "styled-components";
import { Typography } from "@beamcloud/design-system";
import { ICustomerFigures } from "types/interfaces/customers/ICustomer";
import { device } from "constants/Devices";
import { typography } from "screens/Homepage/components/typography";

interface IProps {
  figures: ICustomerFigures[];
}

const Figures: React.FC<IProps> = ({ figures }) => {
  if (!figures || figures.length === 0) return null;

  return (
    <FiguresContainer>
      <FiguresRow $count={figures.length}>
        {figures.map(figure => (
          <FigureItem key={figure.id}>
            <Title20>{figure.metric}</Title20>
            <Typography tag="p" variant="textBase" color="gray300">
              {figure.description}
            </Typography>
          </FigureItem>
        ))}
      </FiguresRow>
    </FiguresContainer>
  );
};

export default Figures;

const FiguresContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 64px;
  padding-right: 64px;
  width: 100%;
`;

const FiguresRow = styled.div<{ $count: number }>`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.$count === 1 ? "center" : "flex-start")};
  gap: 32px;
  max-width: 928px;
  width: 100%;

  @media ${device.tablet} {
    flex-direction: column;
    align-items: center;
  }
`;

const Title20 = styled(Typography).attrs({
  tag: "h3",
  variant: "titleXl",
  color: "white"
})`
  && {
    ${typography.title20};
    margin: 0;
    color: white;
  }
`;

const FigureItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 288px;
  height: 56px;
  gap: 6px;
  border-left: 2px solid rgba(255, 255, 255, 0.5);
  padding-left: 20px;
  align-items: flex-start;

  @media ${device.tablet} {
    width: 100%;
  }
`;
